import React from "react";
import Table, { dateFormatter } from "../../../components/tables/table";
import { formatInstallationTime } from "../../../../utils/helpers";

function getProductData(partidaProducts) {
  let data = [];
  for (let i = 0; i < partidaProducts.length; ++i) {
    const elem = {};
    const product = partidaProducts[i]?.producto;

    elem.tipoUnidad = product?.tipo_unidad?.descripcion;
    elem.referencia = product?.referencia;
    elem.descripcion = product?.descripcion;
    elem.familia = product?.familia?.descripcion;
    elem.tipoProducto = product?.tipo_producto?.descripcion;
    elem.precio = product?.precio + " €";
    elem.unidades = partidaProducts[i]?.unidades;
    elem.tiempo = formatInstallationTime(product?.tiempo_instalacion);
    elem.id = product?.id;

    data = data.concat(elem);
  }
  return data;
}

const PartidaContent = ({ partida }) => {
  const columns = [
    { dataField: "tipoUnidad", text: "Tipo de Unidad", sort: true },
    { dataField: "referencia", text: "Referencia", sort: true },
    {
      dataField: "descripcion",
      text: "Descripción",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "familia",
      text: "Família",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "tipoProducto",
      text: "Tipo",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "precio",
      text: "Precio",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "tiempo",
      text: "Tiempo",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "unidades",
      text: "Unidades",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
  ];

  if (!partida) return <></>;
  return (
    <>
      <div className="row d-flex align-items-center">
        <div className="col-md-4">
          <h5>Descripción</h5>
          <p>{partida?.descripcion}</p>
        </div>
        <div className="col-md-4">
          <h5>Referencia</h5>
          <p>{partida?.referencia}</p>
        </div>
        <div className="col-md-4">
          <h5>Categoría</h5>
          <p>{partida?.categoria?.descripcion}</p>
        </div>
      </div>
      <div className="row d-flex align-items-center">
        <div className="col-12">
          <h5>Concepto</h5>
          <p dangerouslySetInnerHTML={{ __html: partida?.concepto }}></p>
        </div>
        <div className="col-md-4">
          <h5>Fecha Alta</h5>
          <p>{dateFormatter(partida?.fecha_alta) + "h"}</p>
        </div>
      </div>
      <br />
      <h5>Descompuesto</h5>
      <br />
      <Table data={getProductData(partida.productos)} columns={columns} />
    </>
  );
};

export default PartidaContent;
